import {useCallback} from "react";
import {Alert, Spinner} from "react-bootstrap";
import {useAppSelector} from "../hooks";
import {selectWarehouseLocks} from "../../features/AppDataSlice";
import {selectDepartment} from "../../features/AppStateSlice";
import {WarehouseAccess, warehouseAccess, warehouseDateId} from "./warehouseLocks";

export function useWarehouseLocks() {
    const state = useAppSelector(selectWarehouseLocks);
    const department = useAppSelector(selectDepartment);
    return useCallback((date: string | Date | null | undefined, eventId = "WAREHOUSE", itemDepartment: string = department): WarehouseAccess => {
        if (eventId !== "WAREHOUSE") return {blocked: false, locked: false, pending: false, message: ""};
        return warehouseAccess(state, date instanceof Date ? warehouseDateId(date) : date || "", itemDepartment);
    }, [state, department]);
}

export const WarehouseLockNotice = ({access}: {access: WarehouseAccess}) => access.message ?
    <Alert variant={access.pending ? "info" : "warning"} className="py-2 my-2" role="status">
        {access.pending && <Spinner size="sm" className="me-2"/>}{access.message}
    </Alert> : null;
